<template>
    <div class="card position-sticky mt-0 ps-4"> 
        <div class="card-header p-0 pt-4 mb-0 pb-0" style="margin-bottom: 0 !important;">
            <button v-if="priv?.canAddNew" type="button" class="btn me-2 mt-0 mb-0 bg-gradient-success"
                @click="OpenDialog(0, false, null, 'LIST')">
                <span class="btn-text"> <i class="fa fa-plus" style="font-weight:bolder;"></i>&nbsp;&nbsp;Təzə
                    yazı</span>
            </button>
            <button type="button" class="btn mt-0 mb-0" @click="GetLists">
                <span class="btn-text">
                    <i class="fa fa-sync" style="font-weight:bolder;"></i>&nbsp;&nbsp;Yeniləmək</span>
            </button>
            <br />
            <div class="card-body px-0 pt-2 pb-3" v-loading="loading">
                <Table :priv="priv" @open-dialog="OpenDialog" @get-data="GetLists" :data="data"></Table>
            </div>
        </div>
    </div>

    <el-dialog :close-on-click-modal="false" v-model="this.list.dialogVis" width="35%" style="margin-top: 3%;"
        :title="this.editing ? 'Şablon dəyişilməsi' : 'Yeni şablon'" modal-class="modal-class" :destroy-on-close="true">
        <list-dialog :object="list.object" :editing="editing" @close-dialog="this.list.dialogVis = false"
            @insert-dialog="Insert"></list-dialog>
    </el-dialog>
</template>
<script>
import Table from "./Components/Tables/Table.vue";
import ListDialog from "./Components/Dialogs/ListDialog.vue";


export default {
    components: {
        Table,
        ListDialog
    },
    props: {
        priv: Object
    },
    data() {
        return {
            loading: null,
            data: [
                {
                    id: 1,
                    exceptName: "İntihar (adətən müqavilənin ilk 12–24 ayı ərzində)",
                    created: "01.07.2025 14:32",
                    updated: "05.07.2025 10:15"
                },
                {
                    id: 2,
                    exceptName: "Müharibə, hərbi əməliyyatlar, terror aktları",
                    created: "02.07.2025 09:05",
                    updated: "06.07.2025 12:40"
                },
                {
                    id: 3,
                    exceptName: "Cinayət törədərkən ölüm",
                    created: "03.07.2025 17:22",
                    updated: "07.07.2025 08:55"
                },
                {
                    id: 4,
                    exceptName: "Alkoqol/narkotik sərxoşluğu",
                    created: "03.07.2025 17:22",
                    updated: "07.07.2025 08:55"
                }
            ],
            loading2: null,
            data2: [],
            list: {
                dialogVis: false,
                object: null
            },
        }
    },
    methods: {
        GetLists() {

            //None
        },
        GetLists2() {
            this.loading2 = true
            //None
        },
        Insert() {
            if (this.type == 'LIST') {
                this.list.dialogVis = false
                this.GetLists()
            }
        },
        OpenDialog(index, edit, object, type) {
            this.type = type
            this.list.constindex = index
            if (type == 'LIST') {
                this.list.constindex = index
                this.list.dialogVis = true
                this.list.object = object
            }
            this.editing = edit
        }
    },
    mounted() {
        this.GetLists()
        this.GetLists2()
    }
}
</script>